import { AxiosError } from 'axios';
import { api } from '../../../../shared/services/api';
import Cookies from 'js-cookie';

export const acceptDeposit = async (
    accountDepositId: string,
): Promise<{ success: boolean; message?: string }> => {
    try {
        const token = Cookies.get('@token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        };

        const response = await api.get(
            `/archive/response-deposit/${accountDepositId}`,
            config,
        );

        if (response.status === 200 || response.status === 201) {
            return { success: true };
        }

        return {
            success: false,
            message: 'Erro ao aceitar depósito',
        };
    } catch (err) {
        if (err instanceof AxiosError) {
            console.error(
                'Erro ao aceitar depósito:',
                err.response?.data?.error || 'Erro de conexão',
            );
            return {
                success: false,
                message: err.response?.data?.error || err.response?.data?.message || 'Erro de conexão',
            };
        } else {
            console.error('Erro inesperado:', err);
            return { success: false, message: 'Erro inesperado' };
        }
    }
};

export const refuseDeposit = async (
    accountDepositId: string,
    reason?: string,
): Promise<{ success: boolean; message?: string }> => {
    try {
        const token = Cookies.get('@token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        };

        const payload = reason ? { reason } : {};

        const response = await api.put(
            `/archive/refuse-deposit/${accountDepositId}`,
            payload,
            config,
        );

        if (response.status === 200 || response.status === 204) {
            return { success: true };
        }

        return {
            success: false,
            message: 'Erro ao recusar depósito',
        };
    } catch (err) {
        if (err instanceof AxiosError) {
            console.error(
                'Erro ao recusar depósito:',
                err.response?.data?.error || 'Erro de conexão',
            );
            return {
                success: false,
                message: err.response?.data?.error || err.response?.data?.message || 'Erro de conexão',
            };
        } else {
            console.error('Erro inesperado:', err);
            return { success: false, message: 'Erro inesperado' };
        }
    }
};

export const getDepositsAwaitingAcceptance = async (
    page: number = 1,
    limit: number = 8,
): Promise<{
    success: boolean;
    data?: any[];
    totalPages?: number;
    message?: string;
}> => {
    try {
        const token = Cookies.get('@token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: {
                status: 'AWAITING_MANUAL_ACCEPTANCE',
                page,
                limit,
            },
        };

        const response = await api.get('/deposit/getAll', config);
        const { data, meta } = response.data;

        return {
            success: true,
            data: data || [],
            totalPages: meta?.totalPages || 1,
        };
    } catch (err) {
        if (err instanceof AxiosError) {
            console.error(
                'Erro ao buscar depósitos:',
                err.response?.data?.error || 'Erro de conexão',
            );
            return {
                success: false,
                message: err.response?.data?.error || err.response?.data?.message || 'Erro de conexão',
            };
        } else {
            console.error('Erro inesperado:', err);
            return { success: false, message: 'Erro inesperado' };
        }
    }
};
